module.exports = __webpack_public_path__ + "media/images/img07-4484351cfca5bc4cf9e78407729d1190.png";